import React from 'react';
import { useLocalizationContext } from '@im/react-localization';
import { useSocialMedias } from './useSocialMedias';

type Props = {
  height?: string;
  width?: string;
};

export const IngramAppLinks = (props: Readonly<Props>) => {
  const { height = 'auto', width = 'auto' } = props;
  const { locale } = useLocalizationContext();
  const socialMedias = useSocialMedias(locale);

  return (
    <>
      {socialMedias?.appStore?.map((appStore) => (
        <a
          data-name={`${appStore.name}-X4CWeb_LoginPage`}
          href={appStore.url}
          key={appStore.name}
          style={{ height, width }}
        >
          <img
            alt={appStore.name}
            src={appStore.iconImage}
            style={{ display: 'block', height, width }}
          />
        </a>
      ))}
    </>
  );
};
